/* Garbage Juice Theme JS */

(function () {
  'use strict';

  // ── CART DRAWER ──
  const drawer    = document.getElementById('cart-drawer');
  const overlay   = drawer && drawer.querySelector('.cart-drawer__overlay');
  const closeBtn  = drawer && drawer.querySelector('.cart-drawer__close');
  const cartToggles = document.querySelectorAll('.js-cart-toggle');

  function openCart()  { drawer && drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer && drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  cartToggles.forEach(btn => btn.addEventListener('click', openCart));
  overlay  && overlay.addEventListener('click', closeCart);
  closeBtn && closeBtn.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ── ADD TO CART (AJAX) ──
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.classList.contains('product-form')) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn ? btn.textContent : '';

    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    try {
      const data = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Add to cart failed');
      }

      await refreshCart();
      openCart();
    } catch (err) {
      console.error(err);
      if (btn) btn.textContent = 'Try again';
      setTimeout(() => { if (btn) btn.textContent = originalText; }, 2000);
      return;
    } finally {
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    }
  });

  // ── REFRESH CART DRAWER (count + full re-render) ──
  async function refreshCart() {
    try {
      const cart = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(r => r.json());

      // Update count badge(s)
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });

      // Re-render drawer body
      const body  = drawer && drawer.querySelector('.cart-drawer__body');
      const footer = drawer && drawer.querySelector('.cart-drawer__footer');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">Nothing in the bag yet.</p>';
        if (footer) footer.style.display = 'none';
        return;
      }

      body.innerHTML = cart.items.map((item, i) => `
        <div class="cart-item" data-line="${i + 1}">
          <img src="${item.image}" alt="${item.title}" class="cart-item__img" width="80">
          <div class="cart-item__info">
            <p class="cart-item__name">${item.product_title}</p>
            <p class="cart-item__variant">${item.variant_title || ''}</p>
            <p class="cart-item__price">${formatMoney(item.final_price)}</p>
          </div>
          <button class="cart-item__remove js-remove-item" data-line="${i + 1}" aria-label="Remove">✕</button>
        </div>
      `).join('');

      if (footer) {
        footer.style.display = '';
        const subtotal = footer.querySelector('.cart-drawer__subtotal span:last-child');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      }

      // Bind remove buttons
      body.querySelectorAll('.js-remove-item').forEach(btn => {
        btn.addEventListener('click', async function () {
          const line = this.dataset.line;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ line: parseInt(line), quantity: 0 })
          });
          await refreshCart();
        });
      });

    } catch (err) {
      console.error('Cart refresh failed', err);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── PRODUCT PAGE: VARIANT SWITCHING ──
  const optionBtns = document.querySelectorAll('.option-btn');
  const variantInput = document.querySelector('input[name="id"]');
  const addToCartBtn = document.querySelector('.product-form button[type="submit"]');
  const priceEl = document.querySelector('.product-page__price');
  const variants = window.productVariants || [];

  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll('.option-btn.is-selected').forEach(btn => {
      selected[parseInt(btn.dataset.optionPosition)] = btn.dataset.optionValue;
    });
    return selected;
  }

  function findVariant(selected) {
    return variants.find(v =>
      Object.entries(selected).every(([pos, val]) => v.options[parseInt(pos) - 1] === val)
    );
  }

  function updateVariant() {
    const selected = getSelectedOptions();
    const variant = findVariant(selected);

    if (!variant) return;

    // Update hidden input
    if (variantInput) variantInput.value = variant.id;

    // Update price
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update button state
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Bag';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
      }
    }
  }

  optionBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const position = this.dataset.optionPosition;
      document.querySelectorAll(`.option-btn[data-option-position="${position}"]`)
        .forEach(b => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
      updateVariant();
    });
  });

  // ── PRODUCT PAGE: IMAGE GALLERY ──
  document.querySelectorAll('.product-page__img').forEach(img => {
    img.addEventListener('click', function () {
      document.querySelectorAll('.product-page__img').forEach(el => el.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

})();

// ── PRODUCT CARD: IMAGE HOVER + TOUCH CYCLING ──
(function () {
  function initHoverCycling(card) {
    const frames = card.querySelectorAll('.product-img__frame');
    const dots   = card.querySelectorAll('.product-img__dot');
    if (frames.length < 2) return;

    let current = 0;

    function showFrame(index) {
      frames[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = index;
      frames[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    card.addEventListener('mousemove', function (e) {
      const rect  = card.getBoundingClientRect();
      const ratio = (e.clientX - rect.left) / rect.width;
      const index = Math.min(frames.length - 1, Math.floor(ratio * frames.length));
      if (index !== current) showFrame(index);
    });

    card.addEventListener('mouseleave', function () { showFrame(0); });

    let touchStartX = null;
    let touchStartY = null;
    let isSwiping   = false;
    const SWIPE_THRESHOLD = 25;

    card.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping   = false;
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (touchStartX === null) return;
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) isSwiping = true;
      if (isSwiping) e.preventDefault();
    }, { passive: false });

    card.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      const diff = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      touchStartY = null;
      if (!isSwiping || Math.abs(diff) < SWIPE_THRESHOLD) { isSwiping = false; return; }
      isSwiping = false;
      e.preventDefault();
      if (diff < 0) showFrame((current + 1) % frames.length);
      else showFrame((current - 1 + frames.length) % frames.length);
    }, { passive: false });
  }

  function init() {
    document.querySelectorAll('.product-img.js-img-hover').forEach(initHoverCycling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
